import React, { useState } from 'react';
import ReferralSection from '../components/ReferralSection';
import { useAuth } from '../context/AuthContext';
import { useReferral } from '../context/ReferralContext';

const Referrals = () => {
  const { currentUser } = useAuth();
  const { fetchReferrals } = useReferral();
  const [refreshing, setRefreshing] = useState(false);

  const handleRefresh = async () => {
    if (!currentUser) return;
    
    setRefreshing(true);
    await fetchReferrals();
    setTimeout(() => setRefreshing(false), 1000);
  };

  return (
    <div className="bg-white dark:bg-gray-800 shadow-md rounded-lg p-6">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-2xl font-bold text-blue-600 dark:text-blue-400">Referrals</h1>
        {currentUser && (
          <button 
            onClick={handleRefresh}
            className="flex items-center px-3 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition"
            disabled={refreshing}
          >
            <svg 
              className={`h-4 w-4 mr-2 ${refreshing ? 'animate-spin' : ''}`} 
              fill="none" 
              viewBox="0 0 24 24" 
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
            </svg>
            {refreshing ? 'Refreshing...' : 'Refresh'}
          </button>
        )}
      </div>

      <p className="text-gray-600 dark:text-gray-300 mb-6">
        Invite friends and earn 1000 coins for each successful referral!
      </p>
      
      {currentUser ? (
        <ReferralSection key={refreshing ? 'refreshing' : 'idle'} />
      ) : (
        <div className="bg-gray-100 dark:bg-gray-700 p-6 rounded-lg text-center">
          <p className="text-gray-600 dark:text-gray-300 mb-4">
            Please log in to access your referral code and start earning rewards.
          </p>
          <a href="/login" className="inline-block bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition">
            Log In
          </a>
        </div>
      )}
    </div>
  );
};

export default Referrals; 